function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 49,
  r: 8,
  fill: "#7E7AD2"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 202,
  cy: 75,
  r: 8,
  fill: "#7E7AD2"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 39,
  r: 8,
  fill: "#7E7AD2"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 54,
  r: 8,
  fill: "#7E7AD2"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 83,
  r: 8,
  fill: "#7E7AD2"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 121,
  r: 8,
  fill: "#7E7AD2"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 162,
  r: 8,
  fill: "#7E7AD2"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 196,
  r: 8,
  fill: "#7E7AD2"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 211,
  r: 8,
  fill: "#7E7AD2"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 208,
  r: 8,
  fill: "#7E7AD2"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 195,
  cy: 189,
  r: 8,
  fill: "#7E7AD2"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 179.5,
  cy: 20.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 123.5,
  cy: 10.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 67.5,
  cy: 27.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 66.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 120.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 175.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 56.5,
  cy: 220.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.5,
  cy: 242.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 166.5,
  cy: 239.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 215.5,
  cy: 210.5,
  r: 10.5,
  fill: "#69E9F5"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 225.5,
  cy: 55.5,
  r: 10.5,
  fill: "#69E9F5"
});

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 253,
    viewBox: "0 0 236 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.0adbd191.svg";
export { ForwardRef as ReactComponent };